import { injectable } from "inversify";
import Download from "./Download";
import { MimeTypes } from "../types";

@injectable()
export default class DownloadPDFFile extends Download {
  getMimeType(): string {
    return MimeTypes.PDF;
  }

  execute(file: Blob, fileName: string): void {
    super.execute(file, fileName);
  }
}
